import { getJwtToken } from "@/services/getJWT";
import { create } from "zustand";

type UserState = {
    jwt: JWT | undefined;
    setJwt: (jwt: JWT | undefined) => void;
    clearJwt: () => void;
}

export const useUserStore = create<UserState>((set) => ({
    jwt: getJwtToken().jwt,
    setJwt: (jwt: JWT | undefined) => set({ jwt }),
    clearJwt: () => set({ jwt: undefined }),
}))